/**
 * City Class
 * @author Alex Figueroa
 */
window.City = new(function () {

    var that = this;

    /**
     * Init
     * @author Alex Figueroa
     */
    this.init = function () {

        //cambiamos el z-index de los rombos de colores
        that.initZIndex();

        //cambiar el texo de color con el click
        $('#wrap-safetyColors .wrap-colores .content-colors ul li').on('click', that.changeColor);
    };

    /**
     * initZIndex
     * @author Alex Figueroa
     */
    this.initZIndex = function () {

        var z = $('#wrap-safetyColors .wrap-colores .content-colors ul li').length;

        $('#wrap-safetyColors .wrap-colores .content-colors ul li').each(function () {

            $(this).css('z-index', z);

            z--;

        });

    };

    /**
     * changeColor
     * @author Alex Figueroa
     */
    this.changeColor = function (e) {

        var obj = e.currentTarget;
        var color = $(obj).data('color');
        var marginActivo = '-30px';
        var marginNormal = '-20px';
        var z = $('#wrap-safetyColors .wrap-colores .content-colors ul li').length;

        $('#wrap-safetyColors .wrap-colores .content-colors ul li').each(function () {

            if ($(this).hasClass('first')) {
                marginNormal = '0';
                console.log('is first');
            } else {
                marginNormal = '-20px';
            }

            $(this).removeClass('activo noMargin').css({
                'margin-left': marginNormal,
                'z-index': z
            });

            z--;

        });

        if ($(obj).hasClass('first')) {
            marginActivo = '0';
        }

        $(obj).addClass('activo noMargin').css({
            'margin-left': marginActivo,
            'z-index': '100'
        });

        $('#wrap-safetyColors .wrap-colores .content-colors .color-name').html(color);

    };
})();
